import { TriangleAlert } from 'lucide-react';

import { useBanner } from '@/lib/banner';

import { textoDaRevisao } from './tipos';

/**
 * O BANNER DE REVISAR TIPOS (0131, decisão 57; p.33): atenção, com o número,
 * registrado só enquanto `/equipamentos/a-revisar` tiver máquina. A ação
 * "Revisar tipos" abre a lista (`ListaDaRevisao`).
 */
export function useBannerDaRevisao(quantas: number, aoRevisar: () => void): void {
  const texto = quantas > 0 ? `${textoDaRevisao(quantas)}: tipo fora da lista, ou código com o prefixo de outro tipo.` : null;
  useBanner(
    texto === null
      ? null
      : {
          /* O id leva o número: dispensar 3 não cala a quarta. */
          id: `revisar-tipos:${String(quantas)}`,
          gravidade: 'atencao',
          icone: TriangleAlert,
          texto,
          acao: { rotulo: 'Revisar tipos', aoAcionar: aoRevisar },
          rotuloDeFechar: 'Fechar o aviso de tipos para revisar',
        },
  );
}

